import { editPersonalInfo } from 'actions/personalInfo'
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import EditPersonalInfoView from 'views/PersonalInfo/EditPersonalInfoView'
import { format, parse } from 'date-fns'
import constants from 'constants'

class EditPersonalInfo extends Component {
  static propTypes = {
    // editPersonalInfo: PropTypes.func,
    forms: PropTypes.object,
    // formInit: PropTypes.func,
    // formUpdate: PropTypes.func,
    // formSubmit: PropTypes.func,
    // formReset: PropTypes.func,
    hide: PropTypes.func,
    id: PropTypes.string,
    modals: PropTypes.object,
  }
  static defaultProps = {
    id: 'EditPersonalInfo',
  }

  _submit = (data) => {
    const personalInfo = {
      employee_id: data.employee_id,
      // loginname: data.loginname,
      other_name: (data.otherName ? data.otherName : ''),
      status: (data.status ? 1 : 0),
      board_member: (data.boardMember ? 1 : 0),
      seconded_to: (data.secondedTo ? data.secondedTo : ''),
      secondee: (data.secondee ? 1 : 0),
      pension_accrual_date: (data.pensionAccrualDate ? data.pensionAccrualDate : ''),
      draw_down_start_date: (data.drawDownStartDate ? data.drawDownStartDate : ''),
      draw_down_end_date: (data.drawDownEndDate ? data.drawDownEndDate : ''),
      spouse_partner_name: (data.spouseFullLegalName ? data.spouseFullLegalName : ''),
      spouse_partner_birth_date: (data.spouseDateOfBirth ? format(parse(data.spouseDateOfBirth, constants.DATE_FORMAT.STANDARD_AU_NOTIME, new Date()), constants.DATE_FORMAT.STANDARD_ISO) : ''),
      director_id: (data.directorId ? data.directorId : ''),
      allocated_partner_tax_manager: (data.allocatedPartnerTaxManager ? data.allocatedPartnerTaxManager : ''),
    }
    this.props.dispatch(editPersonalInfo(personalInfo, this.props.id))
  }
  render() {
    const {
      modals, hide, forms, id,
    } = this.props

    return (
      <EditPersonalInfoView
        dispatch={this.props.dispatch}
        forms={forms}
        // formInit={formInit}
        // formUpdate={formUpdate}
        // formSubmit={formSubmit}
        // formReset={formReset}
        handleSubmit={this._submit}
        hide={hide}
        id={id}
        modals={modals}
        personalInfo={this.props.personalInfo}
        title="Update Partner data"
      />
    )
  }
}
const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  modals: state.modals,
  forms: state.forms,
  // personalInfo: state.personalInfo
})

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditPersonalInfo))



// WEBPACK FOOTER //
// ./src/containers/EditPersonalInfo.js